export default __webpack_public_path__ + "static/media/funcional.5e399916.svg";